import React from 'react'
import Link from '../common/link'

export default (props) => (
  <Link className="navbar-brand" {...props}></Link>
)